import React from "react";
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import { FaRegAddressCard } from "react-icons/fa6";
import { RiSlideshow3Fill, RiProjector2Fill } from "react-icons/ri";
import { SiWebpack } from "react-icons/si";
import vector from "../assets/vector.png";

type RawFeature = {
  icon: string;
  text: string;
};

type FeatureItem = {
  icon: React.ReactNode;
  text: string;
};

const UseCase = () => {
  const { t } = useTranslation();
  const { ref: countUpRef2 } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const featureIcons = {
    FaRegAddressCard: <FaRegAddressCard className="text-lg" />,
    RiSlideshow3Fill: <RiSlideshow3Fill className="text-lg" />,
    SiWebpack: <SiWebpack className="text-lg" />,
    RiProjector2Fill: <RiProjector2Fill className="text-lg" />
  };

  const rawFeatures = t('usecase.features', { returnObjects: true }) as RawFeature[];

  const features: FeatureItem[] = rawFeatures.map((feature) => ({
    text: feature.text,
    icon: featureIcons[feature.icon as keyof typeof featureIcons] || null
  }));

  return (
    <section className='md:container my-10 min-h-[100vh] lg:min-h-[100vh] flex justify-center items-center'>
      <div className="relative font-secondary">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 sm:py-6">
          <div className="grid max-w-lg grid-cols-1 mx-auto lg:max-w-full lg:grid-cols-2 gap-y-12 lg:gap-x-8 items-center">
            <div className="relative lg:flex lg:flex-col lg:items-start lg:justify-center lg:text-left">
              <div className="text-center lg:text-left">
                <h1 className="text-2xl font-bold leading-tight sm:text-2xl sm:leading-tight lg:leading-tight lg:text-4xl font-primary text-shadow-xl">
                  {t('usecase.title')}
                </h1>
                <p className="mt-2 text-xl sm:mt-10">
                  {t('usecase.description')}
                </p>
              </div>
              <div ref={countUpRef2} className="grid grid-cols-1 md:grid-cols-2 gap-6 my-10 items-center justify-center">
                {features.map((feature, index: number) => (
                  <div key={index} className="flex items-center">
                    <div className="w-10 h-10 flex items-center justify-center bg-blue-500 text-white rounded-full">
                      {feature.icon}
                    </div>
                    <p className="ml-3">{feature.text}</p>
                  </div>
                ))}
              </div>
              <h2 className="mt-2 text-xl sm:mt-8">
                {t('usecase.callToAction')}
              </h2>
            </div>
            <div className="relative max-w-full mx-auto lg:ml-auto lg:max-w-[800px]">
              <img className="w-full" src={vector} alt={t('usecase.imageAlt')} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCase;